<template>
  <v-app>
    <AppHeader
      v-if="$route.name != 'login' && $route.name != 'signup'"
    ></AppHeader>

    <AppAside
      v-if="
        $store.getters.isSupp &&
        $store.getters.loggedin &&
        $route.meta.requiresAuth &&
        !$route.meta.noMenu
      "
    ></AppAside>
    <v-main>
      <v-container
        v-if="
          $route.name != 'login' &&
          $route.name != 'signup' &&
          !$store.getters.isSupp
        "
      >
        <AdminMenu></AdminMenu>
      </v-container>
      <router-view />
      <v-snackbar
        timeout="6000000"
        width="auto"
        right
        v-model="$store.state.connection_snack"
      >
        لايوجد اتصال بالأنترنت
        <template v-slot:action="{ attrs }">
          <v-icon color="white" v-bind="attrs">wifi_off</v-icon>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>
<style scoped></style>
<script>
import AppHeader from "@/layout/AppHeader.vue";
import AppAside from "@/layout/AppAside.vue";
import AdminMenu from "@/layout/AdminMenu";
import FirebaseMixin from "@/mixins/FirebaseMixin";

export default {
  mixins: [FirebaseMixin],
  name: "App",
  data: () => ({}),

  components: {
    AppHeader,
    AdminMenu,
    AppAside,
  },   
  mounted() {

  },
};
</script>

<style lang="scss">
#app {
  background-color: #ddd;
  font-family: "Open Sans", sans-serif;

}

* {
  text-indent: 0;
  letter-spacing:0!important;
}
h1 {
  font-size: 25px;
}
h1,
h2,
h3,
h4,
h5 {
  line-height: 1;
  color: #000;
}

.container {
  // background-color:red;
  @media (min-width: 1400px) {
    &:not(.container--fluid) {
      max-width: 1400px;
      padding-right: 55px;
      padding-left: 55px;
    }
  }
}
th {
  font-weight: bold !important;
  color: #000 !important;
}
td,
th {
  text-wrap: nowrap;
}
.lable_upload {
  max-width: 100%;
  min-width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  margin: 0 auto;
  border-radius: 10px;
  cursor: pointer;
  .v-icon {
    font-size: 70px;
    font-weight: bold;
    color: #000;
  }
}
</style>
